import { motion } from 'framer-motion';

const BusinessSolutions = () => {
  const segments = [
    { icon: 'ri-building-2-line', title: 'Indústrias' },
    { icon: 'ri-tools-line', title: 'Oficinas e Centros Automotivos' },
    { icon: 'ri-store-2-line', title: 'Distribuidoras' },
    { icon: 'ri-file-text-line', title: 'Escritórios e Cartórios' },
    { icon: 'ri-shopping-cart-line', title: 'E-commerces' },
    { icon: 'ri-settings-3-line', title: 'Empresas de Manutenção' },
  ];

  const benefits = [
    'Redução de custos com frota própria',
    'Mais agilidade operacional',
    'Menos paradas de produção',
    'Segurança no transporte',
    'Atendimento sob demanda ou contrato fixo',
    'Escalabilidade conforme crescimento',
  ];

  return (
    <section id="solucoes" className="bg-white py-20">
      <div className="container mx-auto px-6 lg:px-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-block bg-[#1a237e]/10 text-[#1a237e] px-4 py-2 rounded-full text-sm font-semibold mb-4">
              B2B Solutions
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#1a237e] mb-6">
              Soluções Logísticas para Empresas que Não Podem Parar
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Oferecemos soluções de transporte empresarial personalizadas para diversos segmentos, garantindo que sua operação nunca pare por falhas logísticas.
            </p>
            <div className="space-y-4 mb-8">
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-start"
                >
                  <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-[#ff6f00] text-xl"></i>
                  </div>
                  <span className="ml-3 text-gray-700">{benefit}</span>
                </motion.div>
              ))}
            </div>
            <a
              href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-[#ff6f00] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#e66300] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-2-line text-2xl mr-3"></i>
              Falar com Especialista
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 gap-6"
          >
            {segments.map((segment, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-[#f8f9fa] rounded-xl p-6 text-center hover:bg-[#ff6f00]/10 transition-all duration-300 hover:shadow-lg cursor-pointer"
              >
                <div className="flex justify-center mb-4">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <i className={`${segment.icon} text-5xl text-[#1a237e]`}></i>
                  </div>
                </div>
                <h3 className="text-base font-semibold text-[#1a237e]">{segment.title}</h3>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BusinessSolutions;
